import { makeStyles } from '@material-ui/core/styles'
export const useVerificationDialogStyles = makeStyles({
	answerBtn: {
		backgroundColor: '#FFF',
		height: '81px !important',
		margin: '10px 0px',
		width: '80%'
	}
})
